import React, { useEffect, useState, useRef } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { ReactComponent as HiChevronDown } from "../../../../../assets/MainPage/addBlock/countDown/arrow-down.svg";
import { Link, useNavigate } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { ReactComponent as CalendarIcon } from "../../../../../assets/MainPage/addBlock/countDown/calendar.svg";
import { ReactComponent as TextIcon } from "../../../../../assets/MainPage/addBlock/countDown/text.svg";
import { ReactComponent as TextIconDark } from "../../../../../assets/MainPage/addBlock/countDown/text-dark.svg";
import DatePicker from "../../../../../utils/datePicker/DatePicker";
import TimePicker from "../../../../../utils/scrollAbleTimePIcker/TimePicker";

import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";

import { ReactComponent as WatchIcon } from "../../../../../assets/MainPage/addBlock/countDown/clock.svg";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
// redux
import { useDispatch, useSelector } from "react-redux";
import {
  creatingYoutubeBlock,
  resetUser,
} from "../../../../../redux/slices/block/createYoutubeBlockSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";
import { ReactComponent as DownArrow } from "../../../../../assets/settingPage/arrow-down.svg";

import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";
import { I18nextProvider } from "react-i18next";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";

const Countdown = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate, allLangs, tComponent, handleLanguageChange } =
    useLocales();
  const { themeDirection } = useSettings();
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [showDateInput, setShowDateInput] = useState(false);
  const [showTimeInput, setShowTimeInput] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [color, setColor] = useColor("#FFF");

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  useEffect(() => {
    setDigitsColorHandler(color);
  }, [color]);

  const [bgColor, setBgColor] = useColor("#00000066");
  useEffect(() => {
    setCountDownBgColorHandler(bgColor);
  }, [bgColor]);

  const digitColorColrDropDownRef = useRef();
  const digitColorDropDownBtnRef = useRef();
  const countBgColorDropDownRef = useRef();
  const countBgColorDropDownBtnRef = useRef();

  const [colorCountDownBg, setColorCountDownBg] = useState("#00000066");
  const [openCountDownBgColopicker, setOpenCountDownBgColopicker] =
    useState(false);
  const setCountDownBgColorHandler = (color) => {
    setColorCountDownBg(color.hex);
  };
  const [colorCountDownDigits, setColorCountDownDigits] = useState("#FFF");
  const [openDigitsColopicker, setOpenDigitsColopicker] = useState(false);

  const setDigitsColorHandler = (color) => {
    setColorCountDownDigits(color.hex);
  };

  const handleTimeChange = (time) => {
    setSelectedTime(time);
  };
  const handleChange = (date) => {
    setSelectedDate(date);
  };
  const { setActiveMainPageNav } = useStateContext();

  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  // Digits color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openDigitsColopicker &&
        digitColorColrDropDownRef.current &&
        !digitColorColrDropDownRef.current.contains(e.target) &&
        !digitColorDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenDigitsColopicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openDigitsColopicker]);

  // Bg color dropdown handler
  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (
        openCountDownBgColopicker &&
        countBgColorDropDownRef.current &&
        !countBgColorDropDownRef.current.contains(e.target) &&
        !countBgColorDropDownBtnRef.current.contains(e.target)
      ) {
        setOpenCountDownBgColopicker(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openCountDownBgColopicker]);

  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );
  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );
  // CountDown
  const countDownCheck = blockFeature?.some(
    (item) => item.name === "countdown" && paymenetBlocks === 1
  );
  useEffect(() => {
    if (!countDownCheck) {
      navigate("/pricing");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // data needed for calling fetching list
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const usertoken = user.token;
  const linkId = localStorage.getItem("linkId");
  const linkListData = {
    userId,
    usertoken,
    linkId,
  };
  const [subLoader, setSubLoader] = useState(false);

  const submitHandler = async (data) => {
    if (!selectedDate) {
      toast.error("Please select a Date");
      return;
    } else if (!selectedTime) {
      toast.error("Please select Time");
      return;
    } else {
      const newData = {
        coloumnType: "countdown",
        columnName: "countdown",
        language: selectedLang,
        coloumnValue: {
          description: data.description,
          date: selectedDate,
          time: selectedTime,
          digitColor: colorCountDownDigits,
          digitBgColor: colorCountDownBg,
        },
      };

      setSubLoader(true);

      await dispatch(creatingYoutubeBlock(newData));

      setSubLoader(false);
      fetchingLinksList(); // fetching link list after submiting , so list become refresh
    }
  };

  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };

  const { isYoutubeBlockError, isYoutubeBlockSuccess, isYoutubeBlockLoading } =
    useSelector((state) => state?.youtubeBlock);
  const { status, message } = useSelector(
    (state) => state?.youtubeBlock?.youtubeBlock
  );

  useEffect(() => {
    if (status === "success" && isYoutubeBlockSuccess) {
      toast.success(message);
      navigate("/dashboard");
    }
    if (status === "failed" && isYoutubeBlockSuccess) {
      toast.error(message);
    }
    dispatch(resetUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isYoutubeBlockError, isYoutubeBlockSuccess, isYoutubeBlockLoading]);

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
      <>
        <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
          <Link to={"/dashboard/component"}>
            <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
              <div>
                {darkMode ? (
                  <LeftArrowDark
                    className={`${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                ) : (
                  <LeftArrow
                    className={`${
                      themeDirection === "rtl" ? "transform -scale-x-100" : ""
                    }`}
                  />
                )}
              </div>
              <p className="text-heading_color dark:text-color_v1_dark">
                {translate("countdown")}
              </p>
            </div>
          </Link>
        </div>
        <div
          className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-[10px] bg-light_bg_v5 p-[25px] dark:bg-dark-secondary dark:border-color_dark">
            <div className="flex justify-between items-center mb-[20px] sm:mb-[25px] ">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark capitalize">
                {tComponent("addcountdown.add_countdown")}
              </p>
              <div className="flex items-center justify-center">
                <div className="relative w-[115px] sm:w-[145px]">
                  <div
                    onClick={() => {
                      setSelectReporterTypeDropDown(
                        !selectReporterTypeDropDown
                      );
                    }}
                    className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                  >
                    {selectedReporterType
                      ? selectedReporterType
                      : tComponent("addcountdown.select_lang")}
                    <DownArrow />
                  </div>
                  {selectReporterTypeDropDown && (
                    <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                      {allLangs?.map((item, i) => {
                        return (
                          <div
                            key={i}
                            onClick={() => {
                              setSelectedLang(item.value); // Set selected language code
                              setSelectedReporterType(item?.label);
                              setSelectReporterTypeDropDown(false);
                              handleChangeLang(item?.value);
                            }}
                            className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                          >
                            {item.label}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit(submitHandler)}>
              <div className="relative">
                <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex justify-center items-center">
                  {darkMode ? <TextIconDark /> : <TextIcon />}
                </div>
                <input
                  type="text"
                  id="heading"
                  {...register("description", {
                    required: "Description required",
                  })}
                  className={`dark:bg-dark-secondary rounded-lg border bg-light_bg_v5 dark:text-color_v1_dark placeholder:dark:text-font_light_color dark:caret-white p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0 focus:placeholder:text-heading_color focus:placeholder:dark:text-color_v1_dark block w-full ${
                    errors?.description
                      ? "border-state_color_error dark:bg-dark-secondary"
                      : "focus:border-font_light_color border-light_bg_v2 dark:border-color_dark focus:dark:border-font_color"
                  }`}
                  placeholder={tComponent(
                    "addcountdown.enter_countdown_description"
                  )}
                />
              </div>
              {errors?.description && (
                <small className="text-state_color_error text-small3">
                  {errors?.description?.message}
                </small>
              )}
              <div
                className={`flex sm:flex-row md:flex-col xl:flex-row flex-col justify-between gap-[5px] sm:gap-5 sm:mt-[10px] mt-[5px] ${
                  themeDirection === "rtl" ? "flex-row-reverse" : ""
                }`}
              >
                <div className="w-full">
                  {!showDateInput && (
                    <div
                      onClick={() => setShowDateInput(!showDateInput)}
                      className={`relative m-0 `}
                    >
                      <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex items-center">
                        <CalendarIcon className="cursor-pointer" />
                      </div>
                      <input
                        type="text"
                        className="w-full text-heading_color text-small2 sm:text-small1 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] focus:outline-none focus:border-0 rounded-lg bg-light_bg_v4 "
                        placeholder={tComponent("addcountdown.choose_date")}
                        value={tComponent("addcountdown.choose_date")}
                        readOnly
                      />
                      <div
                        onClick={() => console.log("shllj")}
                        className="absolute end-0 inset-y-0 h-full sm:pe-[10px] pe-[16px] flex items-center font-semibold text-heading_color cursor-pointer"
                      >
                        <HiChevronDown />
                      </div>
                    </div>
                  )}
                  {showDateInput && (
                    <DatePicker
                      value={selectedDate}
                      onChange={handleChange}
                      placeholder={tComponent("addcountdown.choose_date")}
                      className=""
                    />
                  )}
                </div>
                <div className="w-full rounded-lg">
                  {showTimeInput && (
                    <TimePicker handleTimeChange={handleTimeChange} />
                  )}
                  {!showTimeInput && (
                    <div
                      onClick={() => setShowTimeInput(!showTimeInput)}
                      className={`relative m-0 `}
                    >
                      <div className="absolute inset-y-0 h-full sm:ps-[10px] ps-[16px] flex items-center">
                        <WatchIcon className="cursor-pointer" />
                      </div>
                      <input
                        type="text"
                        className="w-full text-heading_color text-small2 sm:text-small1 p-[13px] sm:p-[11px] py-[5px] sm:py-[3px] ps-[42px] sm:ps-[36px] px-[14px] sm:px-[16.5px] focus:outline-none focus:border-0 rounded-lg bg-light_bg_v4 "
                        placeholder={"Select Time"}
                        value={tComponent("addcountdown.choose_time")}
                        readOnly
                      />
                      <div className="absolute end-0 inset-y-0 h-full sm:pe-[10px] pe-[16px] flex items-center font-semibold text-heading_color cursor-pointer">
                        <HiChevronDown />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex mt-[13px] md:mt-5 gap-5 items-center flex-col xl:flex-row">
                <div className="relative flex items-center justify-start w-full ">
                  <div
                    ref={digitColorDropDownBtnRef}
                    onClick={() =>
                      setOpenDigitsColopicker(!openDigitsColopicker)
                    }
                    style={{
                      background: colorCountDownDigits,
                    }}
                    className={`rounded-md me-[16px] border lg:me-[19px] cursor-pointer min-w-[48px] w-[48px] min-h-[48px] h-[48px] lg:min-w-[48px] lg:w-[48px] lg:min-h-[48px] lg:h-[48px] relative`}
                  ></div>
                  {openDigitsColopicker && (
                    <div
                      className="absolute top-0 w-full pb-5 "
                      style={{ zIndex: "999999999" }}
                    >
                      <div
                        ref={digitColorColrDropDownRef}
                        className="border bg-white shadow-xl rounded-lg p-3"
                      >
                        <ColorPicker
                          color={color}
                          onChange={setColor}
                          hideInput={true}
                          height={150}
                        />
                        <div className="flex flex-wrap 2xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                          <div className="flex justify-center items-center gap-1 w-full">
                            <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                              <p>HEX</p>
                            </div>
                            <p>:</p>
                            <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                              <p>{color.hex}</p>
                            </div>
                          </div>
                          <div className="flex gap-1 justify-between w-full ">
                            <div className="border rounded-md px-1 py-0.5 text-small1">
                              {Math.round((color.rgb.a / 1) * 100)}%
                            </div>
                            <button
                              className="rounded-full px-3 text-small2_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                              onClick={() => setOpenDigitsColopicker(false)}
                            >
                              DONE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    <div className="text-small3 md:text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
                      {tComponent("addcountdown.timer_digit_color")}
                    </div>
                    <div className="text-small2_b text-heading_color dark:text-color_v1_dark">
                      <input
                        value={colorCountDownDigits}
                        type="text"
                        className="focus:outline-none -mt-[8px] bg-transparent"
                        onChange={(e) => {
                          setColor((color) => {
                            return { ...color, hex: e.target.value };
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="relative flex items-center justify-start w-full ">
                  <div
                    ref={countBgColorDropDownBtnRef}
                    onClick={() =>
                      setOpenCountDownBgColopicker(!openCountDownBgColopicker)
                    }
                    style={{
                      background: colorCountDownBg,
                    }}
                    className={`rounded-md me-[16px] lg:me-[19px] border cursor-pointer min-w-[48px] w-[48px] min-h-[48px] h-[48px] lg:min-w-[48px] lg:w-[48px] lg:min-h-[48px] lg:h-[48px] relative`}
                  ></div>
                  {openCountDownBgColopicker && (
                    <div
                      className="absolute top-0 w-full pb-5 "
                      style={{ zIndex: "999999999" }}
                    >
                      <div
                        ref={countBgColorDropDownRef}
                        className="border bg-white shadow-xl rounded-lg p-3"
                      >
                        <ColorPicker
                          color={bgColor}
                          onChange={setBgColor}
                          hideInput={true}
                          height={150}
                        />
                        <div className="flex flex-wrap 2xl:flex-nowrap justify-center items-center -mt-[8px] gap-2 px-2">
                          <div className="flex justify-center items-center gap-1 w-full">
                            <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                              <p>HEX</p>
                            </div>
                            <p>:</p>
                            <div className="border rounded-md px-1 py-0.5 w-full text-center text-small1">
                              <p>{color.hex}</p>
                            </div>
                          </div>
                          <div className="flex gap-1 justify-between w-full ">
                            <div className="border rounded-md px-1 py-0.5 text-small1">
                              {Math.round((color.rgb.a / 1) * 100)}%
                            </div>
                            <button
                              className="rounded-full px-3 text-small2_b leading-none cursor-pointer bg-main_color text-white hover:opacity-70"
                              onClick={() =>
                                setOpenCountDownBgColopicker(false)
                              }
                            >
                              DONE
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    <div className="text-small3 md:text-small2 text-body_copy_medium_color dark:text-color_v1_dark">
                      {tComponent("addcountdown.timer_background_color")}
                    </div>
                    <div className="text-small2_b text-heading_color dark:text-color_v1_dark">
                      <input
                        value={colorCountDownBg}
                        type="text"
                        className="focus:outline-none -mt-[8px] bg-transparent"
                        onChange={(e) => {
                          setBgColor((color) => {
                            return { ...color, hex: e.target.value };
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex mt-[26px] items-center justify-end">
                <div className="flex justify-center items-center ">
                  {darkMode ? <TrashIconDark /> : <TrashIcon />}
                  <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                    {tComponent("addcountdown.delete_cap")}
                  </p>
                </div>
                <button
                  type="submit"
                  disabled={subLoader}
                  className={`ms-3 rounded-full flex p-1.5 px-[22px] bg-main_color text-white text-small3_b ${
                    subLoader ? "opacity-70" : ""
                  } `}
                >
                  {subLoader ? (
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-3 h-3 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentColor"
                      />
                    </svg>
                  ) : (
                    tComponent("addcountdown.save_cap")
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </>
    </I18nextProvider>
  );
};

export default Countdown;
